// EN translations for Surplify.
// Maintained as a per-language file. See ../i18n.js for init logic.

const en = {
  "app.title": "Surplify",
  "nav.home": "Home",
  "nav.search": "Search",
  "nav.watchlist": "Watchlist",
  "nav.requests": "My Requests",
  "nav.dashboard": "Dashboard",
  "nav.admin": "Admin",
  "nav.import": "Import",
  "nav.myMaterials": "My Materials",
  "nav.login": "Login",
  "nav.register": "Register",
  "nav.logout": "Logout",
  "material.request": "Request Material",
  "material.addToWatchlist": "Add to Watchlist",
  "material.removeFromWatchlist": "Remove from Watchlist",
  "status.reserved": "Reserved",
  "status.pending": "Pending",
  "status.approved": "Approved",
  "status.rejected": "Rejected",
  "status.completed": "Completed",
  "badge.groupOnly": "Group Only",
  "badge.external": "External",
  "badge.slowMoving": "Slow Moving",
  "badge.nonMoving": "Non Moving",
  "badge.missingDocs": "Missing Docs",
  "filter.category": "Category",
  "filter.site": "Site",
  "filter.age": "Age Bucket",
  "filter.manufacturer": "Manufacturer",
  "filter.price": "Price",
  "filter.width": "Width",
  "filter.country": "Country",
  "filter.allCountries": "All Countries",
  "filter.advancedFilters": "Advanced Filters",
  "filter.basicFilters": "Filters",
  "filter.technicalSpecs": "Technical Specifications",
  "filter.materialProperties": "Material Properties",
  "filter.stockDetails": "Stock Details",
  "filter.widthRange": "Width Range",
  "filter.thicknessRange": "Thickness Range",
  "filter.coreDiameter": "Core Diameter",
  "filter.certifications": "Certifications",
  "filter.customerSpecific": "Customer Specific",
  "filter.complianceFlag": "Compliance Flag",
  "filter.compliant": "Compliant",
  "filter.minQuantity": "Minimum Quantity",
  "filter.ageBucket": "Stock Age",
  "filter.age_0_90": "< 3 months",
  "filter.age_91_180": "3-6 months",
  "filter.age_181_360": "6-12 months",
  "filter.age_gt_360": "> 12 months",
  "filter.min": "Min",
  "filter.max": "Max",
  "filter.both": "Both",
  "filter.yes": "Yes",
  "filter.no": "No",
  "filter.quantity": "Quantity",
  "filter.clearAll": "Clear all",
  "filter.clearFilters": "Clear Filters",
  "filter.clearAllFilters": "Clear all filters",
  "filter.filters": "Filters",
  "filter.thickness": "Thickness",
  "filter.core": "Core",
  "filter.qty": "Qty",
  "search.resultsFor": "Results for",
  "search.allMaterials": "All Materials",
  "search.materialsFound": "materials found",
  "search.filtering": "Filtering...",
  "search.tryAdjusting": "Try adjusting your filters or search terms",
  "sort.sortBy": "Sort by",
  "sort.newestFirst": "Newest First",
  "sort.oldestFirst": "Oldest First",
  "sort.priceLowHigh": "Price: Low to High",
  "sort.priceHighLow": "Price: High to Low",
  "sort.quantityHighLow": "Quantity: High to Low",
  "pagination.previous": "Previous",
  "pagination.next": "Next",
  "preset.presets": "Presets",
  "preset.savePreset": "Save Filter Preset",
  "preset.saveDescription": "Give your filter combination a name to quickly apply it later.",
  "preset.name": "Preset Name",
  "preset.namePlaceholder": "e.g., FSC Films > 100mm",
  "preset.nameRequired": "Please enter a preset name",
  "preset.saved": "Preset saved",
  "preset.saveFailed": "Failed to save preset",
  "preset.applied": "Preset \"{name}\" applied",
  "preset.applyFailed": "Failed to apply preset",
  "preset.renamed": "Preset renamed",
  "preset.renameFailed": "Failed to rename preset",
  "preset.deleted": "Preset deleted",
  "preset.deleteFailed": "Failed to delete preset",
  "preset.renamePreset": "Rename Preset",
  "preset.newName": "New Name",
  "preset.deleteConfirm": "Delete Preset?",
  "preset.deleteDescription": "This will permanently delete the preset \"{name}\".",
  "preset.noPresets": "No saved presets",
  "preset.saveHint": "Apply filters and save them",
  "preset.filters": "filters",
  "preset.used": "presets used",
  "preset.rename": "Rename",
  "preset.delete": "Delete",
  "preset.noFiltersToSave": "No active filters to save",
  "preset.maxReached": "Maximum presets reached",
  "preset.saveCurrentFilters": "Save current filters",
  "preset.filtersWillBeSaved": "filters will be saved",
  "status.pendingApproval": "Pending Approval",
  "admin.materialApprovals": "Material Approvals",
  "admin.materialApprovalsDesc": "Review and approve external material listings",
  "admin.noPendingMaterials": "No pending material approvals",
  "admin.submittedBy": "Submitted by",
  "admin.approve": "Approve",
  "admin.reject": "Reject",
  "common.search": "Search materials...",
  "common.loading": "Loading...",
  "common.noResults": "No results found",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.submit": "Submit",
  "common.close": "Close",
  "common.back": "Back",
  "common.saving": "Saving...",
  "common.create": "Create",
  "home.newListings": "New Listings",
  "home.highValue": "High Value Stock",
  "home.featured": "Featured Materials",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.name": "Full Name",
  "auth.loginTitle": "Login to your account",
  "auth.registerTitle": "Create an account",
  "auth.noAccount": "Don't have an account?",
  "auth.hasAccount": "Already have an account?",
  "auth.registrationSuccess": "Registration Successful!",
  "auth.pendingApproval": "Your account has been created and is awaiting admin approval. You will be able to see full material details once approved.",
  "auth.registerDesc": "Create an account to start trading materials",
  "auth.companyGroup": "Company Group",
  "auth.selectCompanyGroup": "Select your company group...",
  "auth.site": "Site / Plant",
  "auth.selectSite": "Select your site...",
  "myMaterials.title": "My Site Materials",
  "myMaterials.articles": "articles",
  "myMaterials.bulkUpload": "Bulk Upload",
  "myMaterials.newArticle": "New Article",
  "myMaterials.searchPlaceholder": "Search articles...",
  "myMaterials.allStatuses": "All Statuses",
  "myMaterials.statusArchived": "Archived",
  "myMaterials.empty": "No articles found",
  "myMaterials.emptyDesc": "No articles have been posted at your site yet.",
  "myMaterials.you": "You",
  "myMaterials.quantity": "Qty",
  "myMaterials.value": "Value",
  "myMaterials.archive": "Archive",
  "myMaterials.deleteTitle": "Delete material?",
  "myMaterials.deleteDesc": "The material and all associated inventory will be permanently deleted.",
  "myMaterials.archiveTitle": "Archive material?",
  "myMaterials.archiveDesc": "The material will be archived and no longer visible in the marketplace.",
  "myMaterials.deleted": "Material deleted",
  "myMaterials.archived": "Material archived",
  "myMaterials.noSite": "Your account has no site assigned.",
  "myMaterials.noSiteTitle": "No site assigned",
  "myMaterials.noSiteDesc": "Please contact an administrator to be assigned to a site.",
  "dashboard.totalInventory": "Total Inventory",
  "dashboard.slowMoving": "Slow Moving (>180 days)",
  "dashboard.nonMoving": "Non Moving (>360 days)",
  "dashboard.pendingRequests": "Pending Requests",
  "dashboard.monthlyTransfers": "Monthly Transfers",
  "dashboard.overdueItems": "Overdue Items",
  "dashboard.subtitle": "Global inventory overview",
  "dashboard.siteFilter": "Filter by site",
  "dashboard.allSites": "All Sites",
  "dashboard.slowMovingDesc": "Materials aging 181-360 days",
  "dashboard.nonMovingDesc": "Materials aging over 360 days",
  "dashboard.transfersDesc": "Internal transfers this month",
  "dashboard.overdueDesc": "Items requiring attention",
  "dashboard.ageChart": "Inventory by Age",
  "dashboard.ageChartDesc": "Distribution of stock value by age bucket",
  "dashboard.siteRanking": "Site Ranking",
  "dashboard.siteRankingDesc": "Sites with most slow-moving inventory",
  "dashboard.overdueTitle": "Overdue Items (>360 days)",
  "dashboard.overdueDesc2": "These items require immediate attention",
  "dashboard.viewAllOverdue": "View all {{count}} overdue items",
  "dashboard.viewNonMoving": "View Non-Moving Stock",
  "dashboard.pendingRequestsLink": "Pending Requests",
  "dashboard.importMaterials": "Import Materials",
  "dashboard.age0_90": "0-90 days",
  "dashboard.age91_180": "91-180 days",
  "dashboard.age181_360": "181-360 days",
  "dashboard.ageGt360": ">360 days",
  "dashboard.slowMovingItems": "Slow Moving Items",
  "dashboard.totalMaterials": "Total Materials",
  "dashboard.totalMaterialsDesc": "Active materials in inventory",
  "dashboard.externalSales": "External Sales",
  "dashboard.externalSalesDesc": "External sales this month",
  "dashboard.sitePending": "Pending Requests",
  "dashboard.sitePendingDesc": "Pending requests for this site",
  "import.title": "Import Materials",
  "import.subtitle": "Import & export material data via Excel",
  "import.downloadTemplate": "Download Template",
  "import.uploadFile": "Upload File",
  "import.validate": "Validate",
  "import.execute": "Execute Import",
  "import.mode.overwrite": "Overwrite All",
  "import.mode.enrich": "Enrich Only",
  "import.mode.selective": "Select Fields",
  "import.export": "Export",
  "import.exportTitle": "Export Materials",
  "import.exportDesc": "Download material data as an Excel file with optional filters",
  "import.exportDownload": "Download Excel",
  "bulk.title": "Bulk Upload",
  "bulk.subtitle": "Import multiple materials at once via Excel/CSV",
  "bulk.downloadTemplate": "Download Template",
  "bulk.dropHint": "Drag & drop your Excel/CSV file here",
  "bulk.browse": "Browse Files",
  "bulk.templateDownloaded": "Template downloaded",
  "bulk.templateError": "Failed to download template",
  "bulk.rowsLoaded": "{{count}} rows loaded",
  "bulk.parseError": "Failed to parse file",
  "bulk.invalidFile": "Invalid file format. Use .xlsx, .xls or .csv",
  "bulk.rows": "Rows",
  "bulk.moreRows": "more rows",
  "bulk.validate": "Validate Data",
  "bulk.validating": "Validating...",
  "bulk.valid": "Valid",
  "bulk.errors": "Errors",
  "bulk.duplicates": "Existing (Update)",
  "bulk.newItems": "New Items",
  "bulk.validationErrors": "Validation Errors",
  "bulk.rowError": "Row {{row}}",
  "bulk.importMode": "Import Mode for Duplicates",
  "bulk.modeEnrich": "Enrich",
  "bulk.modeEnrichDesc": "Only fill empty fields, keep existing",
  "bulk.modeOverwrite": "Overwrite",
  "bulk.modeOverwriteDesc": "Replace all fields with imported values",
  "bulk.executeImport": "Import {{count}} rows",
  "bulk.importing": "Importing...",
  "bulk.importComplete": "Import complete!",
  "bulk.created": "Created",
  "bulk.updated": "Updated",
  "bulk.enriched": "Enriched",
  "bulk.rejected": "Rejected",
  "bulk.importMore": "Import More",
  "bulk.importError": "Import failed",
  "bulk.validateError": "Validation failed",
  "bulk.col.manufacturer_name": "Manufacturer",
  "bulk.col.manufacturer_part_number": "Part Number",
  "bulk.col.article_number": "Article No.",
  "bulk.col.quantity": "Qty",
  "bulk.col.uom": "UoM",
  "bulk.col.number_of_rolls": "Rolls",
  "bulk.col.notes_internal": "Notes",
  "request.title": "Request Material",
  "request.quantity": "Quantity",
  "request.message": "Message (optional)",
  "request.type.internal": "Internal Transfer",
  "request.type.external": "External Inquiry",
  "requests.tab.my": "My Requests",
  "requests.tab.incoming": "Incoming Requests",
  "requests.details": "Request Details",
  "requests.detail.article": "Article",
  "requests.detail.quantity": "Requested Quantity",
  "requests.detail.type": "Type",
  "requests.detail.requestedBy": "Requested By",
  "requests.detail.date": "Date",
  "requests.detail.message": "Message",
  "requests.from": "From",
  "requests.viewDetails": "View Details",
  "requests.loginRequired": "Login Required",
  "requests.loginHint": "Please login to view your requests",
  "requests.empty.my": "No requests sent",
  "requests.empty.myHint": "You haven't made any requests yet. Browse materials and send a request!",
  "requests.empty.incoming": "No incoming requests",
  "requests.empty.incomingHint": "You have no incoming requests for your materials.",
  "requests.action.approve": "Approve",
  "requests.action.reject": "Reject",
  "requests.action.complete": "Mark Complete",
  "requests.action.approveTitle": "Approve Request",
  "requests.action.rejectTitle": "Reject Request",
  "requests.action.completeTitle": "Complete Request",
  "requests.action.approveDesc": "This will approve the request and reserve the material for the requester.",
  "requests.action.rejectDesc": "This will reject the request. The requester will be notified.",
  "requests.action.completeDesc": "This will complete the transfer and update inventory quantities.",
  "requests.action.approvedSuccess": "Request approved",
  "requests.action.rejectedSuccess": "Request rejected",
  "requests.action.completedSuccess": "Request completed - inventory updated",
  "requests.action.failed": "Failed to update request",
  "restricted.title": "Restricted Content",
  "restricted.loginHint": "Please sign in to view prices, quantities, and location details.",
  "restricted.approvalHint": "Your account is pending approval. An administrator will review your registration shortly.",
  "restricted.cardHint": "Sign in and get approved to see details",
  "admin.users": "Users",
  "admin.usersDesc": "Manage user registrations and approvals",
  "admin.noUsers": "No users found",
  "admin.approved": "Approved",
  "admin.pending": "Pending",
  "admin.registeredAt": "Registered",
  "admin.approveUser": "Approve",
  "admin.revokeUser": "Revoke",
  "admin.userApproved": "User approved successfully",
  "admin.userRevoked": "User access revoked",
  "admin.userApproveFailed": "Failed to update user status",
  "admin.deleteUser": "Delete User",
  "admin.deleteUserTitle": "Delete User",
  "admin.deleteUserConfirm": "Are you sure you want to permanently delete user {{name}} ({{email}})? This action cannot be undone.",
  "admin.userDeleted": "User deleted successfully",
  "admin.userDeleteFailed": "Failed to delete user",
  "admin.categoryTree": "Category Tree",
  "admin.categoryTreeDesc": "Manage product categories and their hierarchy",
  "admin.addCategory": "Add Category",
  "admin.editCategory": "Edit Category",
  "admin.deleteCategory": "Delete Category",
  "admin.addCategoryDesc": "Create a new product category",
  "admin.editCategoryDesc": "Edit category name, parent or sort order",
  "admin.deleteCategoryConfirm": "Are you sure you want to delete \"{{name}}\"? This will deactivate the category and hide it from listings.",
  "admin.categoryName": "Category Name",
  "admin.categoryNamePlaceholder": "e.g. Films & Foils",
  "admin.parentCategory": "Parent Category",
  "admin.noParent": "None (root level)",
  "admin.sortOrder": "Sort Order",
  "admin.categoryCreated": "Category created",
  "admin.categoryUpdated": "Category updated",
  "admin.categoryDeleted": "Category deactivated",
  "admin.categoryCreateFailed": "Failed to create category",
  "admin.categoryUpdateFailed": "Failed to update category",
  "admin.categoryDeleteFailed": "Failed to delete category",
  "admin.noCategoriesFound": "No categories found. Click \"Seed Sample Data\" to add defaults.",
  "admin.defaultImage": "Default Image",
  "admin.uploadDefaultImage": "Upload Image",
  "admin.delete": "Delete",
  "create.newTitle": "List Material",
  "create.editTitle": "Edit Material",
  "create.materialInfo": "Material Information",
  "create.title": "Title",
  "create.titlePlaceholder": "e.g. PE Film 500mm transparent",
  "create.description": "Description",
  "create.descPlaceholder": "Detailed description of the material...",
  "create.selectCategory": "Select category",
  "create.companyGroup": "Company Group",
  "create.selectGroup": "Select group",
  "create.partNumber": "Part Number",
  "create.thickness": "Thickness",
  "create.grade": "Material Grade",
  "create.coreDiameter": "Core Diameter",
  "create.materialIndex": "Material Index",
  "create.erpArticleNumber": "ERP Article Number",
  "create.skuInfo": "Stock Data (SKU)",
  "create.addSku": "Add Stock",
  "create.addMore": "Add SKU",
  "create.selectSite": "Select site",
  "create.articleNumber": "Article Number",
  "create.rolls": "Number of Rolls",
  "create.bookValue": "Book Value",
  "create.listPrice": "List Price",
  "create.productionDate": "Production Date",
  "create.customerSpecific": "Customer Specific",
  "create.compliant": "Compliant",
  "create.notesInternal": "Internal Notes",
  "create.notesInternalPlaceholder": "Only visible internally...",
  "create.publish": "Publish",
  "create.materialCreated": "Material created successfully",
  "create.materialUpdated": "Material updated successfully",
  "create.existingSkus": "Existing Stock",
  "create.noNewSkus": "No new stock added",
  "create.previewHint": "Material preview",
  "create.untitled": "Untitled Material",
  "create.titleRequired": "Title is required",
  "create.categoryRequired": "Category is required",
  "create.manufacturerRequired": "Manufacturer is required",
  "create.partNumberRequired": "Part number is required",
  "create.groupRequired": "Company group is required",
  "create.siteRequired": "Site is required",
  "create.articleRequired": "Article number is required",
  "create.quantityRequired": "Quantity is required",
  "create.saveError": "Error saving material",
  "create.photos": "Photos",
  "create.addPhoto": "Photo",
  "create.documents": "Documents (PDF)",
  "create.addDocument": "Add PDF document",
  "create.techSpec": "Technical Data Sheet",
  "create.techSpecHint": "At least one technical data sheet (PDF) is required. Buyers need the specification to evaluate the material.",
  "create.techSpecRequired": "Required",
  "create.addTechSpec": "Upload technical data sheet (PDF)",
  "create.techSpecRequiredError": "Please upload a technical data sheet (PDF) before saving.",
  "admin.masterData": "Master Data",
  "masterData.searchPlaceholder": "Search by supplier, article no...",
  "masterData.matchesFound": "Master data found",
  "masterData.applied": "Master data applied",
  "masterData.appliedLabel": "Master data applied",
  "watchlist.loginRequired": "Login Required",
  "watchlist.loginHint": "Please login to view your watchlist",
  "watchlist.empty": "Your watchlist is empty",
  "watchlist.emptyHint": "Browse materials and click the heart icon to save them here",
  "watchlist.browse": "Browse Materials",
  "watchlist.remove": "Remove",
  "watchlist.priceOnRequest": "Price on request",
  "watchlist.addedOn": "Added on",
  "watchlist.itemCount": "{{count}} items on your watchlist",
  "sustainability.title": "Sustainability Impact",
  "sustainability.subtitle": "Reducing waste through smart material redistribution",
  "sustainability.heroTagline": "Circular Economy for Packaging",
  "sustainability.heroDesc": "Every material redistributed is one less produced from scratch. Together we reduce CO2, save resources, and build a circular manufacturing ecosystem.",
  "sustainability.co2Saved": "CO2 Saved",
  "sustainability.co2SavedDesc": "Estimated emissions prevented",
  "sustainability.materialsRedistributed": "Materials Redistributed",
  "sustainability.materialsRedistributedDesc": "Successfully transferred between sites",
  "sustainability.valueSaved": "Value Preserved",
  "sustainability.valueSavedDesc": "Working capital saved from waste",
  "sustainability.activeSites": "Active Sites",
  "sustainability.activeSitesDesc": "Sites participating in redistribution",
  "sustainability.circularRate": "Circular Economy Rate",
  "sustainability.circularRateDesc": "Materials given a second life",
  "sustainability.atRisk": "Materials at Risk",
  "sustainability.atRiskDesc": "Slow/non-moving stock that could be redistributed",
  "sustainability.pendingRedist": "Pending Redistributions",
  "sustainability.pendingRedistDesc": "Transfers currently being processed",
  "sustainability.availableForReuse": "Available for Reuse",
  "sustainability.impactBanner": "Together, we prevent packaging waste and save resources",
  "sustainability.kgUnit": "kg",
  "sustainability.tonUnit": "t",
  "sustainability.downloadReport": "Download ESG Report",
  "sustainability.downloadReportDesc": "Generate a PDF sustainability report for management",
  "sustainability.reportGenerating": "Generating report...",
  "sustainability.reportReady": "ESG report downloaded successfully",
  "sustainability.reportError": "Failed to generate report",
  "admin.title": "Administration",
  "admin.scenarios": "Scenarios",
  "admin.scenariosTitle": "Scenario Configuration",
  "admin.scenariosDesc": "Configure governance rules and approval workflows",
  "admin.scenarioMode": "Scenario Mode",
  "admin.internalWindow": "Internal Window (days)",
  "admin.internalWindowDesc": "Days items are visible only to internal groups",
  "admin.escalationDays": "Escalation Days",
  "admin.escalationDaysDesc": "Days before escalation notifications",
  "admin.externalEnabled": "External Publishing Enabled",
  "admin.externalEnabledDesc": "Allow materials to be visible externally",
  "admin.approvalRequired": "Approval Required",
  "admin.approvalRequiredDesc": "Require manager approval for requests",
  "admin.strictDocs": "Strict Documentation",
  "admin.strictDocsDesc": "Block imports without spec sheets",
  "admin.saveSettings": "Save Settings",
  "admin.scenarioImpact": "Scenario Impact",
  "admin.scenarioImpactDesc": "Real-time impact of current settings",
  "admin.escalatedRequests": "Escalated Requests",
  "admin.pendingRequests": "Pending Requests",
  "admin.internalWindowItems": "In Internal Window",
  "admin.docsBlocked": "Docs Blocked",
  "admin.externalOpen": "External Open",
  "admin.externalBlocked": "External Blocked",
  "admin.manualApproval": "Manual Approval",
  "admin.autoApproval": "Auto Approval",
  "admin.strictDocsActive": "Strict Documentation Active",
  "admin.settingsSaved": "Settings saved successfully",
  "admin.settingsFailed": "Failed to save settings",
  "admin.seedData": "Seed Sample Data",
  "admin.categories": "Categories",
  "admin.organizations": "Organizations",
  "admin.orgTitle": "Company Groups",
  "admin.orgDesc": "Manage tenant organizations",
  "admin.addGroup": "Add Group",
  "admin.groupName": "Group Name",
  "admin.groupNamePlaceholder": "e.g. Acme Packaging Group",
  "admin.domainsAllowed": "Allowed Domains",
  "admin.noGroups": "No groups found. Add your first company group.",
  "admin.sites": "Sites",
  "admin.sitesTitle": "Sites",
  "admin.sitesDesc": "Manage warehouse locations",
  "admin.addSite": "Add Site",
  "admin.noSites": "No sites found. Add your first warehouse location.",
  "admin.noSitesNoGroup": "Create a company group first before adding sites.",
  "admin.externalCompanies": "External Companies",
  "admin.externalCompaniesDesc": "Manage external company registrations and approvals",
  "admin.addCompany": "Add Company",
  "admin.companyName": "Company Name",
  "admin.companyNamePlaceholder": "e.g. PackPro GmbH",
  "admin.vatId": "VAT ID",
  "admin.contactName": "Contact Name",
  "admin.contactEmail": "Contact Email",
  "admin.contactPhone": "Contact Phone",
  "admin.industry": "Industry",
  "admin.website": "Website",
  "admin.street": "Street",
  "admin.houseNumber": "House Number",
  "admin.postalCode": "Postal Code",
  "admin.city": "City",
  "admin.country": "Country",
  "admin.noCompanies": "No external companies registered yet.",
  "admin.approveCompany": "Approve",
  "admin.rejectCompany": "Reject",
  "admin.companyApproved": "Company approved",
  "admin.companyRejected": "Company rejected",
  "admin.companyCreated": "Company created successfully",
  "admin.companyFailed": "Failed to update company",
  "admin.ndaSigned": "NDA Signed",
  "admin.ndaNotSigned": "NDA Pending",
  "admin.auditLog": "Audit Log",
  "admin.auditLogDesc": "Full history of all system changes",
  "admin.auditEntity": "Entity",
  "admin.auditAction": "Action",
  "admin.auditUser": "User",
  "admin.auditTimestamp": "Timestamp",
  "admin.auditChanges": "Changes",
  "admin.auditNoEntries": "No audit log entries found.",
  "admin.auditFilterEntity": "Filter by entity",
  "admin.auditFilterAction": "Filter by action",
  "admin.auditAll": "All",
  "admin.auditPrevPage": "Previous",
  "admin.auditNextPage": "Next",
  "admin.auditPage": "Page {{page}} of {{pages}}",
  "admin.guide": "Admin Guide",
  "admin.guideTitle": "Administration Guide",
  "admin.guideVotes.title": "Lowest-rated guide sections",
  "admin.guideVotes.desc": "The 5 sections with the most negative user feedback – worth reviewing.",
  "admin.guideVotes.empty": "No votes yet.",
  "admin.guideVotes.loading": "Loading votes…",
  "admin.guideVotes.unknownSection": "Unknown section",
  "admin.guideVotes.score": "Net score (thumbs up − down)",
  "admin.guideDesc": "Comprehensive guide for platform setup, governance, and day-to-day management",
  "admin.platformAdminDesc": "Platform administration - manage all groups, sites, and users",
  "admin.groupAdminDesc": "Manage strategy and users for your company group",
  "admin.groupAdmin": "Group Admin",
  "admin.selectGroup": "Select Company Group",
  "admin.selectGroupPlaceholder": "Choose a group...",
  "admin.loadSettings": "Load Settings",
  "admin.groupUsersDesc": "Manage and approve users within your company group",
  "admin.guideGettingStartedText": "Welcome to Surplify! This platform helps your organization reduce working capital by redistributing slow-moving and non-moving raw materials across sites. After initial setup, your teams can list surplus materials, search for needed items, and transfer inventory between sites or external partners.",
  "admin.guideGettingStarted": "Getting Started",
  "admin.guideGettingStartedSteps": ["Create your Company Group and at least one Site under Admin > Organizations and Sites.", "Seed initial data using the 'Seed Data' button (only needed once for demo/test).", "Invite users by sharing the registration link. Approve new users under Admin > Users.", "Configure your preferred governance mode under Admin > Scenarios.", "Upload materials via the Import page or create them individually."],
  "admin.guideGettingStartedTip": "Use the 'Seed Data' button to populate categories, sample materials, and translations for a quick demo setup.",
  "admin.guideScenarios": "Scenario Configuration",
  "admin.guideScenariosText": "Scenarios control the governance rules for material redistribution. Each mode adjusts visibility windows, escalation thresholds, external access, and approval requirements. You can select a preset or fine-tune each setting individually.",
  "admin.guideScenariosSteps": ["Select a scenario mode: Balanced (default), Conservative, Aggressive Cash, or Crisis Mode.", "Adjust 'Internal Window' (days materials stay internal-only before external publishing).", "Set 'Escalation Days' to trigger automatic notifications for aging pending requests.", "Toggle 'External Enabled' to allow or block external company access.", "Toggle 'Approval Required' for auto-approval or manual review of requests.", "Enable 'Strict Documentation' to block requests for items missing spec sheets."],
  "admin.guideScenariosTip": "The Scenario Impact dashboard shows real-time effects of your current settings, including escalated requests and blocked items.",
  "admin.guideUsers": "User Management",
  "admin.guideUsersText": "Users register through the platform and must be approved before accessing sensitive data such as prices, quantities, and locations. Admins can manage approvals and revoke access at any time.",
  "admin.guideUsersSteps": ["Navigate to Admin > Users to see all registered users.", "Pending users are highlighted with a yellow indicator.", "Click 'Approve' to grant full marketplace access.", "Click 'Revoke' to temporarily disable a user's access.", "Admin users are auto-approved upon registration."],
  "admin.guideUsersTip": "Revoking a user does not delete their account. They can be re-approved at any time.",
  "admin.guideCategories": "Category Management",
  "admin.guideCategoriesText": "Categories organize materials in a hierarchical tree structure. They power the sidebar navigation on the marketplace and help users browse materials by type.",
  "admin.guideCategoriesSteps": ["Navigate to Admin > Categories to view the category tree.", "Click 'Add Category' for a top-level category.", "Click the '+' icon on any category to add a subcategory.", "Edit or delete existing categories using the action buttons.", "Categories can be reordered using the sort order field."],
  "admin.guideCategoriesTip": "Deleted categories are soft-deleted (deactivated). Materials previously assigned to them remain accessible.",
  "admin.guideExternal": "External Companies",
  "admin.guideExternalText": "External companies can self-register on the platform. Platform Admins review applications and approve or reject them. Upon approval, a Company Group and Site are automatically created, and the external users gain marketplace access.",
  "admin.guideExternalSteps": ["External companies register via the public registration form (/register-external).", "Navigate to Admin > External Companies to review pending applications.", "Click 'Approve' to activate the company. This auto-creates their tenant (Group + Site).", "Click 'Reject' to deny access. The company and users are notified via email.", "Approved companies can list their own materials on the marketplace.", "Click on a company row to expand and see linked users."],
  "admin.guideExternalTip": "When you approve or reject, an automatic email notification is sent to the company's contact and linked users.",
  "admin.guideImport": "Excel Import/Export",
  "admin.guideImportText": "The Import page supports bulk material management through Excel file upload. You can download a template, fill in your data, validate it, and then execute the import.",
  "admin.guideImportSteps": ["Navigate to the Import page from the navigation bar.", "Download the Excel template to see the expected column format.", "Fill in your material data and upload the file.", "Review the validation results. Errors are highlighted per row.", "Choose an import mode: Overwrite All, Enrich Only (add missing fields), or Select Fields.", "Execute the import to create or update materials and SKUs."],
  "admin.guideImportTip": "Use 'Enrich Only' mode for incremental updates without overwriting existing data.",
  "admin.guideDashboard": "Dashboard & Reporting",
  "admin.guideDashboardText": "The Dashboard provides real-time KPIs covering inventory age, transfer activity, sustainability metrics, and value at risk. Site managers can filter by site and generate PDF reports.",
  "admin.guideDashboardSteps": ["Navigate to the Dashboard from the navigation bar.", "Review global KPIs: total materials, redistributed quantity, CO2 savings, and value preserved.", "Use the site filter to drill down into site-specific metrics.", "Download ESG/Sustainability PDF reports for management presentations.", "Monitor at-risk materials (slow-moving and non-moving inventory)."],
  "admin.guideDashboardTip": "The sustainability report includes estimated CO2 savings based on redistributed material quantities.",
  "admin.guideNotifications": "Email Notifications",
  "admin.guideNotificationsText": "The platform sends automatic email notifications for escalated requests, new material requests, and external company status changes. All notification history is logged and visible under Admin > Notifications.",
  "admin.guideNotificationsSteps": ["Navigate to Admin > Notifications to view the notification dashboard.", "Review stats: total sent, failed, and by type (New Request, Escalation, External Company).", "Click 'Trigger Check' to manually run the escalation check.", "Browse the notification history with details about recipients and delivery status.", "Email notifications require a configured Resend API key in the backend."],
  "admin.guideNotificationsTip": "Escalation emails are triggered when pending requests exceed the configured 'Escalation Days' threshold in Scenario settings.",
  "admin.guideAudit": "Audit Log",
  "admin.guideAuditText": "The Audit Log provides a complete history of all system changes for compliance and traceability. Every action is tracked with the user, timestamp, entity type, and detailed change data.",
  "admin.guideAuditSteps": ["Navigate to Admin > Audit Log to view the log.", "Use the Entity Type filter (Settings, User, SKU, Material, Request) to narrow results.", "Use the Action filter (Create, Update, Delete, Approve, Revoke) for specific operations.", "Expand the 'Changes' section on any entry to see the exact data that was modified.", "Use pagination to browse through historical entries."],
  "admin.guideAuditTip": "The audit log is immutable and cannot be edited or deleted. Use it for compliance audits and troubleshooting.",
  "admin.notifTypeExtCompany": "Ext. Companies",
  "admin.notifExtApproved": "Approved",
  "admin.notifExtRejected": "Rejected",
  "admin.notifExtCompany": "External Company",
  "admin.mode.balanced": "Balanced",
  "admin.mode.balancedDesc": "Standard governance rules",
  "admin.mode.conservative": "Conservative",
  "admin.mode.conservativeDesc": "Longer windows, more approvals",
  "admin.mode.aggressive_cash": "Aggressive Cash",
  "admin.mode.aggressive_cashDesc": "Shorter windows, faster liquidation",
  "admin.mode.crisis_mode": "Crisis Mode",
  "admin.mode.crisis_modeDesc": "Emergency disposal mode",
  "admin.notifications": "Notifications",
  "admin.notificationsTitle": "Email Notifications",
  "admin.triggerCheck": "Check Now",
  "admin.triggerCheckDesc": "Manually check for escalated requests and send notifications",
  "admin.triggerCheckSuccess": "Escalation check completed",
  "admin.triggerCheckFailed": "Escalation check failed",
  "admin.emailsSent": "Emails Sent",
  "admin.emailsFailed": "Emails Failed",
  "admin.lastCheck": "Last Check",
  "admin.noNotifications": "No notifications sent yet",
  "admin.notifMaterial": "Material",
  "admin.notifRequester": "Requester",
  "admin.notifOwner": "Owner",
  "admin.notifSite": "Site",
  "admin.notifDaysPending": "Days Pending",
  "admin.notifSentAt": "Sent At",
  "admin.notifRecipients": "Recipients",
  "admin.notifStatus": "Status",
  "admin.totalNotifications": "Total Notifications",
  "admin.emailsSkipped": "Skipped",
  "admin.notifTypeNewRequest": "New Request",
  "admin.notifTypeEscalation": "Escalation",
  "admin.notifRequestedQty": "Requested Qty",
  "admin.notificationsDesc": "Email notification history (escalation & new requests)",
  "ext.registerTitle": "Register as External Company",
  "ext.registerDesc": "Register your company to offer materials on the marketplace.",
  "ext.companyInfo": "Company Details",
  "ext.userAccount": "User Account",
  "ext.nextStep": "Next: User Account",
  "ext.backStep": "Back",
  "ext.submitRegistration": "Submit Registration",
  "ext.fillRequired": "Please fill in all required fields",
  "ext.passwordMismatch": "Passwords do not match",
  "ext.passwordTooShort": "Password must be at least 6 characters",
  "ext.confirmPassword": "Confirm Password",
  "ext.registrationSuccess": "Registration Successful!",
  "ext.registrationPending": "Your company is now under review. You will be notified once your access has been activated.",
  "ext.alreadyRegistered": "Already registered?",
  "ext.internalUser": "Internal user?",
  "ext.registerInternal": "Register here",
  "ext.registerAsExternal": "Register as external company",
  "ext.myCompany": "My Company",
  "ext.portalTitle": "Company Portal",
  "ext.pendingTitle": "Approval Pending",
  "ext.pendingMessage": "Your registration is currently being reviewed. Once approved, you can offer materials on the marketplace.",
  "ext.rejectedTitle": "Registration Rejected",
  "ext.rejectedMessage": "Unfortunately your registration was rejected. Please contact support for more information.",
  "ext.myListings": "My Listings",
  "ext.createListing": "List Material",
  "ext.noListings": "No materials listed yet",
  "ext.noListingsDesc": "List your first material to offer it on the marketplace.",
  "ext.createFirstListing": "List First Material",
  "ext.noCompanyLinked": "No external company linked to your account",
  "ext.linkedUsers": "Linked Users",
  "ext.noLinkedUsers": "No linked users",
  "ext.registrationType": "Type",
  "ext.chooseRegistrationType": "How would you like to register?",
  "ext.registerAsGroup": "As Group",
  "ext.registerAsGroupDesc": "Company with multiple sites/locations",
  "ext.registerAsSite": "As Single Site",
  "ext.registerAsSiteDesc": "Single location without a parent group",
  "ext.registerGroupDesc": "Register your group to participate in the marketplace with multiple sites.",
  "ext.registerSiteDesc": "Register your site as a single location on the marketplace.",
  "ext.continue": "Continue",
  "ext.groupName": "Group Name",
  "ext.siteName": "Site Name",
  "ext.materialDeleted": "Material deleted",
  "ext.deleteConfirmTitle": "Delete material?",
  "ext.deleteConfirmDesc": "Are you sure you want to delete this material? This action cannot be undone.",
  "common.view": "View",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.deleting": "Deleting...",
  "status.available": "Available",
  "status.documentation_missing": "Docs missing",
  "status.archived": "Archived",
  "footer.tagline": "Governance-driven marketplace for surplus packaging materials. Reduce working capital through smart redistribution.",
  "footer.marketplace": "Marketplace",
  "footer.forPartners": "For Partners",
  "footer.support": "Support",
  "footer.legalTitle": "Legal",
  "footer.agb": "Terms & Conditions",
  "footer.impressum": "Legal Notice",
  "footer.datenschutz": "Privacy Policy",
  "footer.datenschutzeinstellungen": "Privacy Settings",
  "footer.rights": "All rights reserved.",
  "admin.legalPages": "Legal Pages",
  "admin.platformSettings": "Settings",
  "admin.resendEmail": "Resend email",
  "admin.legalPagesDesc": "Edit Support, Terms, Imprint, Privacy and Privacy Settings pages",
  "admin.legalPageTitle": "Page Title",
  "admin.legalPageContent": "Page Content (HTML)",
  "admin.legalPreview": "Preview",
  "nav.myGroup": "My Group",
  "nav.scenario": "Scenario",
  "nav.groupRequests": "Site Requests",
  "groupRequests.title": "Incoming Site Requests",
  "groupRequests.subtitle": "Requests directed at your group's sites",
  "groupRequests.pending": "pending",
  "groupRequests.filterAll": "All Statuses",
  "groupRequests.empty": "No incoming site requests",
  "groupRequests.emptyHint": "There are currently no requests directed at your sites.",
  "groupRequests.site": "Target Site",
  "dashboard.categoryBreakdown": "Category Breakdown",
  "dashboard.categoryBreakdownDesc": "Top categories by value at risk",
  "dashboard.topRisk": "Top Risk Materials",
  "dashboard.topRiskDesc": "Highest value slow/non-moving materials",
  "dashboard.valueAtRisk": "Value at Risk",
  "dashboard.valueAtRiskDesc": "Book value of slow/non-moving stock",
  "dashboard.totalValue": "Total Inventory Value",
  "dashboard.totalValueDesc": "Total book value of all active SKUs",
  "dashboard.agingAutoCalculated": "Aging is auto-calculated from production date",
  "dashboard.kEUR": "kEUR",
  "dashboard.items": "Items",
  "dashboard.skus": "SKUs",
  "group.title": "My Group Materials",
  "group.subtitle": "All materials across sites in your company group",
  "group.allSites": "All Sites",
  "group.filterSite": "Filter by Site",
  "group.filterStatus": "Filter by Status",
  "group.noMaterials": "No materials found in your group",
  "group.ownMaterial": "Own Material",
  "group.otherSite": "Other Site",
  "group.skuCount": "{{count}} SKUs",
  "group.totalValue": "Total Value",
  "group.sites": "Sites",
  "scenario.title": "Scenario What-If Analysis",
  "scenario.subtitle": "Preview the impact of governance changes before applying them",
  "scenario.currentSettings": "Current Settings",
  "scenario.whatIf": "What-If Preview",
  "scenario.applyChanges": "Apply Changes",
  "scenario.preview": "Preview Impact",
  "scenario.previewResult": "Projected Impact",
  "scenario.escalatedRequests": "Escalated Requests",
  "scenario.pendingRequests": "Pending Requests",
  "scenario.docsBlocked": "Docs Blocked",
  "scenario.internalWindow": "In Internal Window",
  "scenario.externalAccess": "External Access",
  "scenario.autoApproved": "Auto-Approved",
  "scenario.valueAtRisk": "Value at Risk",
  "scenario.itemsAtRisk": "Items at Risk",
  "scenario.noChanges": "Adjust the settings and click 'Preview Impact' to see the effect",
  "scenario.enabled": "Enabled",
  "scenario.blocked": "Blocked",
  "nav.standardMaterials": "Standard Materials",
  "nav.transactions": "Transactions",
  "nav.matching": "Material Matching",
  "nav.analytics": "Analytics",
  "nav.language": "Language",
  "nav.switchGroup": "Switch Group",
  "matching.title": "Material Matching",
  "matching.subtitle": "Automatic matching of surpluses with demand from other sites",
  "matching.refresh": "Refresh",
  "matching.matches": "Matches",
  "matching.matchRate": "Match Rate",
  "matching.potSavings": "Pot. Savings",
  "matching.sites": "Sites",
  "matching.surplusAvailable": "{{count}} surpluses available",
  "matching.demandPositions": "{{count}} demand positions",
  "matching.matchedQuantity": "{{count}} kg matched quantity",
  "matching.providers": "{{count}} providers",
  "matching.consumers": "{{count}} consumers",
  "matching.topMaterials": "Top Materials with Matches",
  "matching.offerSite": "Offer Site",
  "matching.demandSite": "Demand Site",
  "matching.manufacturer": "Manufacturer",
  "matching.searchManufacturer": "Search manufacturer...",
  "matching.allSites": "All Sites",
  "matching.noMatches": "No matches found",
  "matching.noMatchesDesc": "No matches between surpluses and demand lists were found.",
  "matching.matchesFound": "{{count}} match(es) found",
  "matching.material": "Material",
  "matching.provider": "Provider",
  "matching.consumer": "Consumer",
  "matching.quantity": "Quantity",
  "matching.bookValue": "Book Value",
  "matching.age": "Age",
  "matching.width": "Width",
  "matching.widthFit": "Fit",
  "matching.widthDeviation": "Dev.",
  "matching.action": "Action",
  "matching.view": "View",
  "matching.age0_90": "0–90 days",
  "matching.age91_180": "91–180 days",
  "matching.age181_360": "181–360 days",
  "matching.ageGt360": "> 360 days",
  "analytics.title": "Analytics & Reporting",
  "analytics.subtitle": "Trend analysis, site performance, and matching evaluations",
  "analytics.tabTrends": "Trends",
  "analytics.tabSites": "Sites",
  "analytics.tabMatching": "Matching",
  "analytics.last6Months": "Last 6 months",
  "analytics.last12Months": "Last 12 months",
  "analytics.last24Months": "Last 24 months",
  "analytics.inventoryTrend": "Inventory Trend",
  "analytics.inventoryTrendDesc": "Monthly development of article count and inventory value",
  "analytics.articles": "Articles",
  "analytics.valueKEUR": "Value (kEUR)",
  "analytics.transactionVolume": "Transaction Volume",
  "analytics.transactionVolumeDesc": "Monthly transactions",
  "analytics.transactions": "Transactions",
  "analytics.requestTrend": "Request Trend",
  "analytics.requestTrendDesc": "Total vs. completed requests",
  "analytics.requests": "Requests",
  "analytics.completed": "Completed",
  "analytics.siteComparison": "Site Comparison: Inventory Value",
  "analytics.siteComparisonDesc": "Total value (kEUR) by site",
  "analytics.redistributionRanking": "Redistribution Ranking",
  "analytics.redistributionRankingDesc": "Completed redistributions per site",
  "analytics.redistributions": "Redistributions",
  "analytics.openRequests": "Open Requests",
  "analytics.siteDetails": "Site Details",
  "analytics.site": "Site",
  "analytics.value": "Value (kEUR)",
  "analytics.slowMoving": "Slow Moving",
  "analytics.redistributed": "Redistributed",
  "analytics.demand": "Demand",
  "analytics.noSiteData": "No site data available",
  "analytics.kpiMatches": "Matches",
  "analytics.kpiMatchRate": "Match Rate",
  "analytics.kpiMatchedValue": "Matched Value",
  "analytics.kpiMaterials": "Materials",
  "analytics.topMatchedMaterials": "Top Matched Materials",
  "analytics.categoryDistribution": "Matches by Category",
  "analytics.sitePairFlows": "Site Flows (Provider → Consumer)",
  "analytics.sitePairFlowsDesc": "Most frequent material flows between sites",
  "analytics.noData": "No data",
  "analytics.noMatchingData": "No matching data available",
  "transactions.title": "Transactions",
  "transactions.subtitle": "All completed and open transactions",
  "transactions.allStatuses": "All Statuses",
  "transactions.statusCompleted": "Completed",
  "transactions.statusCancelled": "Cancelled",
  "transactions.statusPending": "Open",
  "transactions.total": "Transactions",
  "transactions.completed": "Completed",
  "transactions.totalValue": "Total Value",
  "transactions.date": "Date",
  "transactions.material": "Material",
  "transactions.type": "Type",
  "transactions.seller": "Seller",
  "transactions.buyer": "Buyer",
  "transactions.quantity": "Quantity",
  "transactions.value": "Value",
  "transactions.fee": "Fee",
  "transactions.status": "Status",
  "transactions.rating": "Rating",
  "transactions.internal": "Internal",
  "transactions.external": "External",
  "transactions.empty": "No transactions yet",
  "transactions.emptyDesc": "Transactions are automatically created when requests are completed.",
  "transactions.rate": "Rate",
  "transactions.rated": "Rated",
  "transactions.rateTitle": "Rate Transaction",
  "transactions.counterparty": "Counterparty",
  "transactions.unknown": "Unknown",
  "transactions.commentLabel": "Comment (optional)",
  "transactions.commentPlaceholder": "How was the cooperation?",
  "transactions.submitRating": "Submit Rating",
  "transactions.submitting": "Submitting...",
  "transactions.ratingSuccess": "Rating submitted",
  "transactions.ratingError": "Error submitting rating",
  "transactions.ratingRequired": "Please rate at least one category",
  "transactions.loadError": "Error loading transactions",
  "transactions.reviews": "Reviews",
  "transactions.noReviews": "No reviews yet.",
  "transactions.comments": "Comments",
  "transactions.group": "Group",
  "transactions.review": "reviews",
  "notifications.title": "Notifications",
  "notifications.allRead": "All read",
  "notifications.none": "No notifications",
  "notifications.noFiltered": "No matching notifications",
  "notifications.filterAll": "All",
  "notifications.filterMatches": "Matches",
  "notifications.filterOther": "Other",
  "notifications.newMatch": "{{count}} new material match",
  "notifications.newMatches": "{{count}} new material matches",
  "notifications.goToDashboard": "Go to Dashboard",
  "notifications.matchDashboard": "Show Material Matching Dashboard",
  "notifications.justNow": "just now",
  "notifications.minutesAgo": "{{count}} min ago",
  "notifications.hoursAgo": "{{count}} hrs ago",
  "notifications.daysAgo": "{{count}} d ago",
  "notifications.site": "Site",
  "notifications.typeMatch": "Match",
  "notifications.typeApproval": "Approval Match",
  "notifications.typeRequest": "Request",
  "notifications.typeEscalation": "Escalation",
  "notifications.typeLogistics": "Logistics",
  "notifications.typeInfo": "Info",
  "partners.heroTitle": "Buy. Sell. Reuse. Surplus Materials — Smarter.",
  "partners.heroSubtitle": "Join the packaging industry's leading surplus marketplace. Access verified materials from top manufacturers and save up to 40% on procurement costs.",
  "partners.ctaRegister": "Register as Partner",
  "partners.ctaBrowse": "Browse Materials",
  "partners.trust1": "Free registration",
  "partners.trust2": "Verified suppliers",
  "partners.trust3": "No commitment",
  "partners.howItWorksLabel": "Process",
  "partners.howItWorksTitle": "How It Works",
  "partners.howItWorksSubtitle": "Three simple steps to start saving on your material procurement.",
  "partners.step1Title": "Register",
  "partners.step1Desc": "Create your company account in minutes. Our team verifies your company and activates your access.",
  "partners.step2Title": "Browse",
  "partners.step2Desc": "Search thousands of verified surplus materials from packaging manufacturers. Filter by type, quantity, and location.",
  "partners.step3Title": "Request",
  "partners.step3Desc": "Send a request directly to the supplier. The platform manages the entire process from negotiation to delivery.",
  "partners.benefitsTitle": "Why Partner With Surplify",
  "partners.benefit1Title": "Save up to 40%",
  "partners.benefit1Desc": "Access surplus materials at a fraction of original cost. Real savings on PE films, labels, foils, and more.",
  "partners.benefit2Title": "Verified Quality",
  "partners.benefit2Desc": "Every listing includes manufacturer data, specifications, and condition reports. Buy with full confidence.",
  "partners.benefit3Title": "ESG Impact",
  "partners.benefit3Desc": "Every purchase reduces CO2 emissions and prevents waste. Get full traceability for your sustainability reporting.",
  "partners.trustTitle": "Trusted by Industry Leaders",
  "partners.trustSubtitle": "Companies across Europe already rely on Surplify",
  "partners.trustUsers": "50+ companies",
  "partners.trustStat1": "40%",
  "partners.trustStat1Label": "Average cost savings",
  "partners.trustStat2": "500+",
  "partners.trustStat2Label": "Verified material listings",
  "partners.trustStat3": "50+",
  "partners.trustStat3Label": "Active partner companies",
  "partners.ctaFinalTitle": "Ready to Start Saving?",
  "partners.ctaFinalDesc": "Join hundreds of companies already using Surplify to reduce procurement costs and hit ESG targets.",
  "partners.ctaFinalRegister": "Get Started — It's Free",
  "partners.noCredit": "No credit card required. Free registration.",
  "demo.badge": "Book a Demo",
  "demo.ctaHero": "Book a Demo",
  "demo.title": "See Surplify in Action",
  "demo.subtitle": "Book a free, personalized demo with our team. We'll show you how Surplify can optimize your material procurement and reduce costs.",
  "demo.point1": "Live walkthrough of the platform",
  "demo.point2": "Tailored to your industry & needs",
  "demo.point3": "No obligation — completely free",
  "demo.name": "Name",
  "demo.namePlaceholder": "Your full name",
  "demo.email": "Business Email",
  "demo.emailPlaceholder": "name@company.com",
  "demo.company": "Company",
  "demo.companyPlaceholder": "Your company name",
  "demo.phone": "Phone (optional)",
  "demo.phonePlaceholder": "+49 ...",
  "demo.message": "Message (optional)",
  "demo.messagePlaceholder": "Tell us about your needs...",
  "demo.submit": "Request Demo",
  "demo.sending": "Sending...",
  "demo.privacy": "We respect your privacy. Your data will only be used to contact you about your demo request.",
  "demo.requiredFields": "Please fill in all required fields.",
  "demo.successToast": "Demo request sent successfully!",
  "demo.errorToast": "Failed to send demo request. Please try again.",
  "demo.successTitle": "Thank You!",
  "demo.successDesc": "Your demo request has been received. Our team will contact you within 24 hours to schedule your personalized demo.",
  "onboarding.step": "Step",
  "onboarding.of": "of",
  "onboarding.skip": "Skip for now",
  "onboarding.next": "Next",
  "onboarding.finish": "Get Started",
  "onboarding.restartTour": "Restart tour",
  "onboarding.step1Title": "Welcome to Surplify",
  "onboarding.step1Desc": "Surplify is the packaging industry's leading surplus marketplace. Find, request, and trade verified surplus materials.",
  "onboarding.step1Points": ["Browse thousands of verified materials", "Save up to 40% vs. new procurement", "Track your ESG impact automatically"],
  "onboarding.step2Title": "Your Company Profile",
  "onboarding.step2Desc": "Your profile represents your company on the platform. A complete profile increases trust and helps others find you.",
  "onboarding.step2Points": ["Add your company logo and description", "Verify your contact details", "Set your material preferences"],
  "onboarding.step3Title": "Finding Materials",
  "onboarding.step3Desc": "Use the powerful search to find exactly what you need. Filter by material type, dimensions, quantity, and location.",
  "onboarding.step3Points": ["Search by manufacturer or article number", "Filter by category, country, and quantity", "Save materials to your watchlist"],
  "onboarding.step4Title": "Requesting Materials",
  "onboarding.step4Desc": "Found what you need? Send a request directly to the supplier. The platform handles the entire process.",
  "onboarding.step4Points": ["Specify your required quantity", "Add a message to the supplier", "Track request status in real-time"],
  "app.subtitle": "to make surplus useful",
  "auth.loginError": "Invalid email or password",
  "auth.loginSuccess": "Login successful!",
  "auth.passwordTooShort": "Password must be at least 6 characters",
  "auth.passwordsNoMatch": "Passwords do not match",
  "auth.registerError": "Registration failed",
  "filter.allCategories": "All Categories",
  "home.loginRequired": "Please login to use watchlist",
  "home.materialsCount": "materials",
  "home.noMaterials": "No materials found.",
  "home.seedDescription": "You can seed some sample data to get started.",
  "home.seedError": "Failed to seed data",
  "home.seedSuccess": "Data seeded successfully! Refreshing...",
  "home.seeding": "Seeding...",
  "home.watchlistError": "Failed to update watchlist",
  "home.hero.badge": "Circular B2B · Print & Packaging",
  "home.hero.verified": "EU-verified",
  "home.hero.headlineA": "Reuse.",
  "home.hero.headlineB": "Repair.",
  "home.hero.headlineC": "Redistribute.",
  "home.hero.subtitle": "Surplify is the circular B2B marketplace for the printing and packaging industry — giving surplus materials, spare parts and used machines a second life. Every transaction avoids virgin production, saves CO₂ and preserves working capital.",
  "home.hero.impactPrefix": "Together saved so far:",
  "home.hero.impactSuffix": "of CO₂",
  "home.hero.searchPlaceholder": "Manufacturer, part no., material, model…",
  "home.hero.searchBtn": "Search",
  "home.hero.verticalMaterials": "Surplus",
  "home.hero.verticalSpareParts": "Spare Parts",
  "home.hero.verticalMachines": "Machines",
  "home.hero.verticalPaints": "Inks & Coatings",
  "home.hero.ctaPostWanted": "Post a buyer request",
  "home.hero.ctaForSellers": "For sellers",
  "home.hero.ctaGuide": "Help & guide",
  "home.hero.trustVies": "EU VIES VAT-verified",
  "home.hero.trustCompanies": "Verified company accounts",
  "home.hero.trustCircular": "Circular economy",
  "home.newco.badge": "New to Surplify?",
  "home.newco.title": "Your company on the B2B marketplace in 3 steps",
  "home.newco.subtitle": "Surplus material, residues, paints, spare parts and used printing machines — all on one platform. Start for free, trade fairly, document in a REACH/CLP-compliant way.",
  "home.newco.step1Title": "Create your company",
  "home.newco.step1Desc": "Company name, VAT ID, address — VIES-validated",
  "home.newco.step2Title": "Create your first listing",
  "home.newco.step2Desc": "Material, paint, spare part or machine — fill in the form, done",
  "home.newco.step3Title": "Receive requests & sell",
  "home.newco.step3Desc": "Commission only on successful transactions. No setup fees.",
  "home.newco.ctaRegister": "Register your company now",
  "home.newco.ctaPartners": "For partners & enterprise",
  "home.newco.disclaimer": "Free starter plan · No credit card required · GDPR & B2B-compliant",
  "home.newco.whatYouGet": "What you get",
  "home.newco.freeTier": "On the free starter plan",
  "home.newco.feat1Label": "4 material verticals",
  "home.newco.feat1Sub": "Materials · Paints · Spare parts · Machines",
  "home.newco.feat2Label": "Unlimited listings",
  "home.newco.feat2Sub": "No quantity limits on the standard plan",
  "home.newco.feat3Label": "Matching algorithm",
  "home.newco.feat3Sub": "Buyer requests are matched automatically",
  "home.newco.feat4Label": "REACH/CLP compliance",
  "home.newco.feat4Sub": "Safety data sheets & GHS pictograms integrated",
  "home.newco.feat5Label": "Sustainability reporting",
  "home.newco.feat5Sub": "CO₂ savings are documented automatically",
  "home.newco.freeBadge": "Start 100% free",
  "home.pillar.materials.label": "Surplus",
  "home.pillar.materials.title": "Surplus & Materials",
  "home.pillar.materials.desc": "Films, paper, rolls and semi-finished stock — kept in the loop instead of incinerated.",
  "home.pillar.materials.metric": "active listings",
  "home.pillar.spareParts.label": "Spare Parts",
  "home.pillar.spareParts.title": "Spare Parts & Modules",
  "home.pillar.spareParts.desc": "OEM parts reused — every component saved avoids new extraction and production.",
  "home.pillar.spareParts.metric": "new",
  "home.pillar.machines.label": "Machines",
  "home.pillar.machines.title": "Printing Machines",
  "home.pillar.machines.desc": "Used presses replace new ones — up to 80 % less CO₂ than buying fresh off the line.",
  "home.pillar.machines.metric": "available",
  "home.pillar.paints.label": "Inks & Coatings",
  "home.pillar.paints.title": "Inks, Varnishes & Additives",
  "home.pillar.paints.desc": "Surplus printing inks, lacquers and chemical additives — kept in production instead of disposed of as hazardous waste.",
  "home.pillar.paints.metric": "in stock",
  "home.sustain.liveImpact": "Live Impact",
  "home.sustain.co2": "CO₂ saved",
  "home.sustain.redistributed": "redistributed",
  "home.sustain.sites": "sites",
  "home.sustain.circular": "circular rate",
  "home.sustain.atRisk": "at risk",
  "home.machines.label": "Vertical · Machines",
  "home.machines.title": "Used printing machines, given a second production cycle.",
  "home.machines.subtitle": "Every used press replaces a newly built one — with a fraction of the embodied CO₂ and raw materials. Inspection optional, compatibility verified.",
  "home.machines.seeAll": "All machines",
  "home.machines.emptyDesc": "No printing machines listed yet.",
  "home.machines.emptyCreate": "Create listing",
  "home.spareParts.label": "Vertical · Spare Parts",
  "home.spareParts.title": "OEM spare parts — kept in circulation.",
  "home.spareParts.subtitle": "Unused stock, obsolescence buffers, decommissioned lines. We route parts back into production instead of to scrap.",
  "home.spareParts.seeAll": "All spare parts",
  "home.spareParts.emptyDesc": "No spare parts listed yet.",
  "home.spareParts.emptyCreate": "Create first listing",
  "home.paints.label": "Vertical · Inks & Coatings",
  "home.paints.title": "Surplus inks, varnishes and additives — back in the press.",
  "home.paints.subtitle": "Discontinued shades, leftover batches, retired stock. We bring printing chemicals back into production instead of paying disposal fees.",
  "home.paints.seeAll": "All inks & coatings",
  "home.paints.emptyDesc": "No inks, varnishes or additives listed yet.",
  "home.paints.emptyCreate": "Create first listing",
  "home.materials.label": "Vertical · Surplus",
  "home.materials.title": "Surplus & production overstock.",
  "home.materials.subtitle": "Live stock from production runs, warehouse clearings and quality returns — looped straight back into the industry.",
  "home.trust.vies.title": "EU VIES VAT",
  "home.trust.vies.desc": "Automated verification of VAT IDs for every registered company.",
  "home.trust.companies.title": "Verified companies",
  "home.trust.companies.desc": "Only vetted B2B accounts get full marketplace access.",
  "home.trust.csv.title": "Bulk CSV import",
  "home.trust.csv.desc": "List thousands of spare parts and materials in a single upload.",
  "home.trust.circular.title": "Circular economy",
  "home.trust.circular.desc": "Every redistribution avoids virgin production and cuts scope-3 emissions.",
  "machine.card.label": "Printing machine",
  "machine.card.year": "Year",
  "machine.card.hours": "hrs",
  "machine.card.width": "Width",
  "machine.card.price": "Price",
  "sparePart.card.label": "Spare part",
  "sparePart.card.compatible": "Compatible:",
  "sparePart.card.single": "Single item",
  "sort.dateAdded": "Date Added",
  "sort.price": "Price",
  "sort.quantity": "Quantity"
};

export default en;
